module.exports = __webpack_public_path__ + "img/icon-pfeil-slider_links_schwarz.dcaa5dd2.svg";